
















































































import { Inject } from '@cds/common';
import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import { statisticsApi } from '@/services/statistics-service';//新的接口 换这里
@Component({
    components: {

    }
})
export default class personStatistics extends Vue {
    [x: string]: any;
    public form: any = {
        pageSize: 10, currentPage: 1, processState: ''
    };
    public datacreateTime: any[] = [];
    private tableData: any[] = [
    ];
    public doStatus: any[] = [
        {
            name: '全部',
            id: '',
        },
        {
            name: '成功', 
            id: '1',
        },
        {

            name: '失败',
            id: '0',
        }  
    ];
    public loading: Boolean = false;
    @Inject(statisticsApi) private statisticsApi!: statisticsApi;
    public async created(): Promise<void> {
        await this.getList();
    }
    public search() {
        this.getList()
    }
    // 重置
    public reset() {
        this.form = {
            pageSize: this.form.pageSize,
            currentPage: 1,
            processState: ''
        };
        this.datacreateTime = [];
        this.getList();
    }
    //分页相关
    public handleSizeChange(size: number) {
        this.form.pageSize = size;
        this.getList();
    }
    public handleCurrentChange(current: number) {
        this.form.currentPage = current;
        this.getList();
    }
    //获取数据源
    public async getList() {
        var that = this;
        that.loading = true;
        if (that.datacreateTime && that.datacreateTime.length > 0) {
            that.form.createTimeEnd = that.datacreateTime[1]
            that.form.createTimeStart = that.datacreateTime[0]
        } else {
            delete that.form.createTimeStart
            delete that.form.createTimeEnd
        }
        const res = await that.statisticsApi.getpasswordList(that.form);
        that.tableData = res.records;
        that.form.total = res.total;
        that.form.pages = res.pages;
        that.form.pageSize = res.size;
        that.form.currentPage = res.current;
        that.loading = false;
        if (res.records.length <= 0) {
            that.form.pages = 1;
            that.form.pageSize = 10;
            that.form.currentPage = 1;
            that.form.total = 0;
        }
    }
    //完成处理
    private async doAnything(row: any): Promise<void> {
        let param = {
            id: row.id
        }
        try {
            await this.$confirm('确认处理完成?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'info'
            });
            await this.statisticsApi.editSure(param);
            this.getList()
            this.$message({
                message: '处理完成',
                type: 'success'
            });
        } catch (e) {
            this.$message({
                type: 'info',
                message: '已取消处理'
            });
        }
    }
    private mounted() {
        document.onkeydown = (e) => {
            let key = (window.event as any).keyCode;
            if (key == 13) {
                this.search()
            }
        }
    }
}
